import { render, staticRenderFns } from "./iosIndex.vue?vue&type=template&id=5bed28d7&scoped=true"
import script from "./iosIndex.vue?vue&type=script&lang=js"
export * from "./iosIndex.vue?vue&type=script&lang=js"
import style0 from "./iosIndex.vue?vue&type=style&index=0&id=5bed28d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed28d7",
  null
  
)

export default component.exports